import Grid from "@material-ui/core/Grid";
import CoreLoginDefauld from "./coreLoginDefauld";
const onMainLogin = () => {
	return (
		<Grid className="from-view-main">
			<Grid item xs={12}>
				<div className="paper-box">
					<CoreLoginDefauld />
				</div>
			</Grid>
		</Grid>
	);
};

export default onMainLogin;
